<template>
  <div id="app">
    <keep-alive>
      <Header />
    </keep-alive>
    <transition>
      <router-view />
    </transition>
    <Popover />
    <keep-alive>
      <Footer />
    </keep-alive>
  </div>
</template>

<script>
import Footer from './components/layout/Footer'
import Header from './components/layout/Header'
import Popover from './components/layout/popover'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  components: {
    Footer: Footer,
    Header: Header,
    Popover: Popover
  }
}
</script>

<style>

.call {
  position: fixed;
  width: 74px;
  height: 74px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid #ddd;
  border-radius: 50%;
  right: 71px;
  bottom: 40px;
  z-index: 99;
  padding: 3px 3px 0 3px;
  border-radius: 50%;
  box-shadow: 5px 5px 20px #e9e2ee;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue